<template>
  <div class="end-tip">
    <slot>
      <el-input v-bind="$attrs" v-on="$listeners" />
    </slot>
    <el-tooltip class="item" effect="dark" :content="$t(content)">
      <i class="my-icon-question" />
    </el-tooltip>
  </div>

</template>

<script>
export default {
  props: {
    // eslint-disable-next-line
    content: {}
  }
}
</script>

<style lang="scss" scoped>
.end-tip {
  position: relative;
  .item {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%)
  }
}
</style>
